export enum UserRole {
    Admin = 'admin',
    Anonymous = 'anonymous'
}
